<template>
  <el-dialog v-if="dialogVisibleParticipate" title="投票" :visible.sync="dialogVisibleParticipate" width="850px" @close="dialogVisibleParticipate = false">
    <div class="title">
      <p v-text-lbl="'promoter'" :voteName="voteResult.voteName">发起人： {{ voteResult.voteName }}</p>
      <p v-text-lbl="'deadline'" :endTime="vo.endTime"> 截止时间： {{ vo.endTime }}</p>
    </div>
    <div v-for="(item,index) in vo.passenger['passenger']" :key="index" class="subject">
      <ul class="voteInfo">
        <li>{{ item.subject }}（{{ voteTypeArr[item.voteType-1] }}）</li>
        <li v-for="(choice, _index) in item.passenger['passenger']" :key="_index">
          <input
            v-if="voteResult.choiceStatus==1"
            :id="choice.id"
            :value="choice.subject"
            :name="choice.subjectId"
            :type="item.voteType==1?'radio':'checkbox'"
            :voteType="item.voteType"
            :voteSubName="item.voteSubName"
            :voteSubId="item.id"
            :voteResId="voteResult.id"
            class="choiceOpt"
          >
          <label>{{ choice.subject }}</label>
          <div v-if="voteResult.choiceStatus==2 && vo.isOpen==1" class="tjinfo fr">
            <span v-text-lbl="'voto'" :num="choice.voteNum"> {{ choice.voteNum }} 票</span>
            <span v-if="totleVoteNum!=0">&nbsp;{{ choice.votePercent }}%</span>
          </div>
          <div v-if="voteResult.choiceStatus==2&&vo.isOpen==1" :id="choice.id" :ref="'tpprocess'+choice.id" class="tpprocess" />
          <div v-if="voteResult.choiceStatus==2&&vo.isOpen==2" :id="choice.id" class="myprocess" />
        </li>
        <li v-if="voteResult.choiceStatus==2&&vo.isOpen==1">
          <span v-text-lbl="'total'" class="fl"> 合计 </span>
          <span v-text-lbl="'voto'" class="fr" :num="item.voteNum"> {{ item.voteNum }} 票</span>
        </li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="+voteResult.choiceStatus === 1" v-text-lbl="'voting'" @click="submitVoteResInfo"> 投票 </el-button>
      <el-button v-pageBtn-lbl="'close'" @click="dialogVisibleParticipate = false"> 关闭 </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
    components: {

    },
    props: {

    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'voteManage',
            dialogVisibleParticipate: false,
            id: '',
            account: '',
            orgCode: '',
            voteResult: {},
            vo: {},
            // voteTypeArr: ['单选', '多选'],
            voteTypeArr: [this.$tx('hygl.voteManage.Radio', '单选'), this.$tx('hygl.voteManage.multipleChoice', '多选')],
            totleVoteNum: '',
            myChoiceList: {},
            choiceTotle: 0,
            resInfoList: []
        }
    },
    computed: {

    },
    created() {
        this.$bus.$on('openMyParticipate', this.openMyParticipate)
    },
    beforeDestroy() {
        this.$bus.off('openMyParticipate', this.openMyParticipate)
    },
    mounted() {

    },
    methods: {
        openMyParticipate(row) {
            this.dialogVisibleParticipate = true
            this.id = row.id
            this.account = row.account
            this.orgCode = row.orgCode
            this.startVote()
        },
        startVote() {
            // const arr = [
            //     {
            //         'account': 'zhangxunpeng',
            //         'choiceStatus': 2,
            //         'deptId': '319e317244604e64a422fd6fbcc12181',
            //         'deptName': 'ICT产品研发运营部',
            //         'id': '20653c4e89ad423cbc43a4a97304feb3',
            //         'orgCode': 'plat',
            //         'orgName': '湖南中移通信技术工程有限公司',
            //         'passenger': {},
            //         'phoneNumber': '13304521416',
            //         'status': 1,
            //         'voteId': 'ce099292fc3e4d25acde9bb1ea317fc4',
            //         'voteName': '张训鹏'
            //     }
            // ]
            // this.voteResult = arr[0]
            // this.getByIdFunc()
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/voteResult/querydata',
                data: [
                    { compare: '=', field: 'voteId', merge: true, value: this.id },
                    { compare: '=', field: 'orgCode', merge: true, value: this.orgCode },
                    { compare: '=', field: 'account', merge: true, value: this.account }
                ]
            }).then(res => {
                if (res.code === 'success') {
                    this.voteResult = res.data.body.listdata[0]
                    this.getByIdFunc()
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 获取投票主题信息
         */
        getByIdFunc() {
            // const obj = {
            //     'account': 'hexun',
            //     'creatTime': '2020-06-08 15: 34: 44',
            //     'endTime': '2020-06-30 15: 34: 00',
            //     'id': 'ce099292fc3e4d25acde9bb1ea317fc4',
            //     'isOpen': 1,
            //     'orgCode': 'plat',
            //     'orgName': '湖南中移通信技术工程有限公司',
            //     'passenger': {
            //         'passenger': [
            //             {
            //                 'id': '0828e711872c46b795cbe491eb798ed5',
            //                 'orderNo': 1,
            //                 'passenger': {
            //                     'passenger': [
            //                         {
            //                             'id': 'cdb1df4fccb24131afc86cffcb587b30',
            //                             'orderNo': 1,
            //                             'passenger': {},
            //                             'status': 1,
            //                             'subject': '1',
            //                             'subjectId': '0828e711872c46b795cbe491eb798ed5'
            //                         },
            //                         {
            //                             'id': 'c372b773b5ff40439a79caa78eaccd32',
            //                             'orderNo': 2,
            //                             'passenger': {},
            //                             'status': 1,
            //                             'subject': '2',
            //                             'subjectId': '0828e711872c46b795cbe491eb798ed5'
            //                         }
            //                     ]
            //                 },
            //                 'status': 1,
            //                 'subject': '测试',
            //                 'voteId': 'ce099292fc3e4d25acde9bb1ea317fc4',
            //                 'voteType': 1
            //             }
            //         ]
            //     },
            //     'personId': '2555045d72424ff7a8087182a7868d19',
            //     'personName': '张训鹏',
            //     'sponsor': '贺勋',
            //     'startTime': '2020-06-01 15: 34: 00',
            //     'status': 1,
            //     'voteRange': 2,
            //     'voteStatus': 3,
            //     'voteTheme': '测试5',
            //     'voteType': 1
            // }
            // this.vo = obj
            // if (+this.voteResult.choiceStatus === 2) {
            //     // 已投票，显示统计
            //     this.getQueryThemeVoters()
            //     this.getQuerydataByTheme()
            //     this.queryCurUserStat()
            // }
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/vote/getById',
                params: { id: this.id }
            }).then(res => {
                if (res.code === 'success') {
                    this.vo = res.data.body.vo
                    if (this.voteResult.choiceStatus === 2) {
                        // 已投票，显示统计
                        this.getQueryThemeVoters()
                        this.getQuerydataByTheme()
                        this.queryCurUserStat()
                    }
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 查询主题投票人数
         */
        getQueryThemeVoters() {
            // this.totleVoteNum = 1
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/vote/queryThemeVoters',
                params: { themeId: this.id }
            }).then(res => {
                if (res.code === 'success') {
                    this.totleVoteNum = res.data.body.voters
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 查询选项投票统计
         */
        getQuerydataByTheme() {
            // const resList = {
            //     '测试': { 1: 1, 2: 0 }
            // }
            // this.vo.passenger['passenger'].forEach((item, i) => {
            //     item.voteNum = 0
            //     item.passenger['passenger'].forEach((choice, j) => {
            //         choice.voteNum = resList[item.subject][choice.subject]
            //         // 计算每道题目总的票数
            //         item.voteNum += choice.voteNum
            //     })
            // })
            // setTimeout(() => {
            //     this.vo.passenger['passenger'].forEach((item, i) => {
            //         item.passenger['passenger'].forEach((choice, j) => {
            //             // 保证所有百分比加起来为1
            //             if (j === item.passenger['passenger'].length - 1) {
            //                 if (choice.voteNum > 0) {
            //                     let temp = 100
            //                     for (let k = 0; k < item.passenger['passenger'].length - 1; k++) {
            //                         temp -= item.passenger['passenger'][k]['votePercent']
            //                     }
            //                     choice.votePercent = temp
            //                 } else {
            //                     choice.votePercent = 0
            //                     let temp = 100
            //                     for (let k = 0; k < item.passenger['passenger'].length - 2; k++) {
            //                         temp -= item.passenger['passenger'][k]['votePercent']
            //                     }
            //                     item.passenger['passenger'][j - 1]['votePercent'] = temp
            //                 }
            //             } else {
            //                 if (choice.voteNum > 0) {
            //                     choice.votePercent = Math.round(choice.voteNum / item.voteNum * 100)
            //                 } else {
            //                     choice.votePercent = 0
            //                 }
            //             }
            //             $('#' + choice.id + '.tpprocess').width(choice.votePercent + '%')
            //         })
            //     })
            // }, 0)
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/voteResult/querydataByTheme',
                params: { themeId: this.id }
            }).then(res => {
                if (res.code === 'success') {
                    const resList = res.data.body.listdata
                    this.vo.passenger['passenger'].forEach((item, i) => {
                        item.voteNum = 0
                        item.passenger['passenger'].forEach((choice, j) => {
                            choice.voteNum = resList[item.subject][choice.subject]
                            // 计算每道题目总的票数
                            item.voteNum += choice.voteNum
                        })
                    })
                    setTimeout(() => {
                        this.vo.passenger['passenger'].forEach((item, i) => {
                            item.passenger['passenger'].forEach((choice, j) => {
                                // 保证所有百分比加起来为1
                                if (j === item.passenger['passenger'].length - 1) {
                                    if (choice.voteNum > 0) {
                                        let temp = 100
                                        for (let k = 0; k < item.passenger['passenger'].length - 1; k++) {
                                            temp -= item.passenger['passenger'][k]['votePercent']
                                        }
                                        choice.votePercent = temp
                                    } else {
                                        choice.votePercent = 0
                                        let temp = 100
                                        for (let k = 0; k < item.passenger['passenger'].length - 2; k++) {
                                            temp -= item.passenger['passenger'][k]['votePercent']
                                        }
                                        item.passenger['passenger'][j - 1]['votePercent'] = temp
                                    }
                                } else {
                                    if (choice.voteNum > 0) {
                                        choice.votePercent = Math.round(choice.voteNum / item.voteNum * 100)
                                    } else {
                                        choice.votePercent = 0
                                    }
                                }
                                $('#' + choice.id + '.tpprocess').width(choice.votePercent + '%')
                            })
                        })
                    }, 0)
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 查询当前用户投票信息
         */
        queryCurUserStat() {
            // const obj = [
            //     {
            //         'choiceId': 'cdb1df4fccb24131afc86cffcb587b30',
            //         'choiceName': '1',
            //         'id': '571b35df850b4c6fa84092297afd5055',
            //         'passenger': {},
            //         'resultId': '20653c4e89ad423cbc43a4a97304feb3',
            //         'status': 1,
            //         'subjectId': '0828e711872c46b795cbe491eb798ed5',
            //         'subjectName': '测试',
            //         'voteType': 1
            //     }
            // ]
            // this.myChoiceList = obj
            // this.myChoiceList.forEach((item, i) => {
            //     this.$nextTick(() => {
            //         $('#' + item.choiceId).css('background', '#FFB693')
            //     })
            // })
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/voteResultInfo/querydata',
                data: [
                    {
                        'compare': '=',
                        'field': 'resultId',
                        'merge': true,
                        'value': this.voteResult.id
                    }
                ]
            }).then(res => {
                if (res.code === 'success') {
                    this.myChoiceList = res.data.body.listdata
                    this.myChoiceList.forEach((item, i) => {
                        this.$nextTick(() => {
                            $('#' + item.choiceId).css('background', '#FFB693')
                        })
                    })
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 进行投票
         */
        submitVoteResInfo() {
            // 投票校验
            let canSubmit
            $('.subject').each(function(index, ele) {
                canSubmit = false
                $(ele).find('.choiceOpt').each(function(i, e) {
                    if (e.checked) {
                        canSubmit = true
                        return false
                    }
                })
                if (!canSubmit) {
                    return false
                }
            })
            if (!canSubmit) {
                this.$alert(this.$tx('hygl.voteManage.notSelevtTopit', '操作提示'))
                return
            }
            this.choiceTotle = 0
            $('.choiceOpt').each(function(index, ele) {
                if (ele.checked) {
                    this.choiceTotle++
                }
            })
            setTimeout(function() {
                $('.choiceOpt').each(function(index, ele) {
                    if (ele.checked) {
                        const tmpObj = {
                            resultId: $(ele).attr('voteResId'),
                            subjectId: $(ele).attr('voteSubId'),
                            subjectName: $(ele).attr('voteSubName'),
                            voteType: $(ele).attr('voteType'),
                            choiceId: $(ele).attr('id'),
                            choiceName: $(ele).attr('value'),
                            status: 1
                        }
                        this.initResultInfo(tmpObj)
                    }
                })
            }, 0)
        },
        /**
         * 初始化投票结果明细
         */
        initResultInfo(obj) {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/voteResultInfo/addNew'
            }).then(res => {
                if (res.data.code === 'success') {
                    const resobj = res.data.body.vo
                    resobj.resultId = obj.resultId
                    resobj.subjectId = obj.subjectId
                    resobj.subjectName = obj.subjectName
                    resobj.voteType = obj.voteType
                    resobj.choiceId = obj.choiceId
                    resobj.choiceName = obj.choiceName
                    resobj.status = obj.status
                    this.resInfoList.push(resobj)
                    if (this.resInfoList.length === this.choiceTotle) {
                        this.saveVoteResInfo(this.resInfoList[0])
                    }
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 投票明细保存
         */
        saveVoteResInfo(resobj) {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: resobj,
                url: 'hygl/voteResultInfo/insert'
            }).then(res => {
                if (res.data.code === 'success') {
                    this.resInfoList.splice(0, 1)
                    if (this.resInfoList.length > 0) {
                        this.saveVoteResInfo(this.resInfoList[0])
                    } else {
                        this.$alert(this.$tx('hygl.voteManage.voteed', '您已完成投票'), this.$tx('common.operationTip', '操作提示'), { type: 'success' })
                        this.voteResult.choiceStatus = 2
                        // 更新用户是否投票的状态
                        this.$http({
                            method: 'PUT',
                            contentType: 'application/x-www-form-urlencoded',
                            data: this.voteResult,
                            url: 'hygl/voteResult/update'
                        }).then(res => {
                            if (res.data.code === 'success') {
                                // 显示统计
                                this.getQueryThemeVoters()
                                this.getQuerydataByTheme()
                                this.queryCurUserStat()
                                // this.$parent.bootstrapTableRefresh();
                            } else {
                                this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                            }
                        })
                    }
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.subject {
  margin: 20px 0;
  .voteInfo {
    border: 1px solid #E0E0E0;
    border-bottom: none;
    list-style: none;
    padding: 0;
  }
  li {
    border-bottom: 1px solid #E0E0E0;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    z-index: 0;
    position: relative;
    overflow: hidden;
  }
  label {
    font-weight: 400;
  }
}
.tpprocess {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  background: #C4E0FF;
}
</style>
